import { TournamentCard } from '../cards';

const TournamentList = ({
  tournaments = [],
  isAdminView = false,
  onTournamentClick,
  entityType = null,
  emptyStateMessage = 'No tournaments found',
  isLoading = false,
}) => {
  if (isLoading) {
    return <div className="alert alert-secondary py-2 mb-0">Loading tournaments...</div>;
  }

  if (!Array.isArray(tournaments) || tournaments.length === 0) {
    return <div className="alert alert-info py-2 mb-0">{emptyStateMessage}</div>;
  }

  return (
    <div className="row g-3">
      {tournaments.map((tournament) => {
        const tournamentId = tournament?._id?.toString?.() || tournament?._id || tournament?.id;
        return (
          <div key={tournamentId} className="col-12 col-lg-6">
            <TournamentCard
              tournament={tournament}
              onClick={onTournamentClick}
              showActions={isAdminView}
              isAdminView={isAdminView}
              entityType={entityType}
            />
          </div>
        );
      })}
    </div>
  );
};

export default TournamentList;
